import React from "react";
import {GlobalOutlined, SendOutlined} from "@ant-design/icons";

/**
 * How a conversation's source is presented, everywhere it is shown.
 *
 * <p>Lives here rather than in one screen because the operator console and the chat-history table
 * must agree: an operator who learns that green-globe means "web chat" in one place should not have
 * to relearn it in the other.
 *
 * <p>The backend never sends NULL — a legacy row with no channel column is reported as
 * {@code TELEGRAM} — but anything unrecognised falls back to Telegram anyway, because every chat
 * that predates the widget genuinely is one.
 */
export const channelMeta = (channel, t) => {
    const tr = typeof t === "function" ? t : (_k, d) => d;
    return channel === "WEB"
        ? {
            key: "WEB",
            label: tr("ch.channel_web", "چت آنلاین سایت"),
            shortLabel: tr("ch.channel_web_short", "وب‌سایت"),
            color: "green",
            icon: <GlobalOutlined/>,
        }
        : {
            key: "TELEGRAM",
            label: tr("ch.channel_telegram", "تلگرام"),
            shortLabel: tr("ch.channel_telegram_short", "تلگرام"),
            color: "blue",
            icon: <SendOutlined/>,
        };
};

/** The two sources, for filter dropdowns. */
export const CHANNEL_OPTIONS = (t) => [
    {value: "WEB", label: channelMeta("WEB", t).label},
    {value: "TELEGRAM", label: channelMeta("TELEGRAM", t).label},
];
